// Magnetic Flux units with conversion factors to weber (Wb)
export const magneticFluxUnits = [
  { id: 'weber', name: 'Weber', symbol: 'Wb', plural: 'Webers', factor: 1 },
  { id: 'milliweber', name: 'Milliweber', symbol: 'mWb', plural: 'Milliwebers', factor: 1e-3 },
  { id: 'microweber', name: 'Microweber', symbol: 'µWb', plural: 'Microwebers', factor: 1e-6 },
  { id: 'volt-second', name: 'Volt-second', symbol: 'V·s', plural: 'Volt-seconds', factor: 1 },
  { id: 'maxwell', name: 'Maxwell', symbol: 'Mx', plural: 'Maxwells', factor: 1e-8 },
  { id: 'kiloline', name: 'Kiloline', symbol: 'kline', plural: 'Kilolines', factor: 1e-5 },
  { id: 'line', name: 'Line', symbol: 'line', plural: 'Lines', factor: 1e-8 },
  { id: 'tesla-square-meter', name: 'Tesla Square Meter', symbol: 'T·m²', plural: 'Tesla Square Meters', factor: 1 },
  { id: 'gauss-square-centimeter', name: 'Gauss Square Centimeter', symbol: 'G·cm²', plural: 'Gauss Square Centimeters', factor: 1e-8 },
];

export const popularMagneticFluxConversions = [
  { from: 'weber', to: 'maxwell' },
  { from: 'maxwell', to: 'weber' },
  { from: 'weber', to: 'milliweber' },
  { from: 'milliweber', to: 'weber' },
  { from: 'volt-second', to: 'weber' },
  { from: 'weber', to: 'microweber' },
];

export const getUnitById = (id) => magneticFluxUnits.find(unit => unit.id === id);

export const convertMagneticFlux = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert magnetic flux units and learn the conversion formula.`;
};
